import React from "react";
import './OurClient.css';

const OurClients = () => {
  return (
    <div className="our-clients overflow-hidden py-8">
      <h1 className="text-center text-2xl font-bold mb-8">Our Clients</h1>
      <div className="clients-slider mt-5">
        <div className="clients-track">
          {[..."1","2","3","4","5","6","7","8","9","10","11","12","13","14","15","16","17","18","19","20","21","22"].map((client, index) => (
            <img key={index} src={`assets/images/clients/${client}.png`} alt={`Client ${client}`} className="client-logo" />
          ))}
          {/* Duplicate images for the looping effect */}
          {[..."1","2","3","4","5","6","7","8","9","10","11","12","13","14","15","16","17","18","19","20","21","22"].map((client, index) => (
            <img key={`dup-${index}`} src={`assets/images/clients/${client}.png`} alt={`Client ${client}`} className="client-logo" />
          ))}
        </div>
      </div>
    </div>
  );
};

export default OurClients;
